import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { module } from "app/modules/equipment-registration/equipment-registration.module";
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormComponent } from 'app/modules/equipment-registration/component/form-component/form.component';
import { MawopService } from 'app/modules/equipment-registration/services/mawop.service';
import { MawopCalculator, OptionItem } from 'app/modules/equipment-registration/model/mawop.model';
import { FuseConfirmationService } from '@fuse/services/confirmation';

@Component({
    selector: 'app-mawop-calculator-form-modal',
    templateUrl: './mawop-calculator-form-modal.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: module,
    styleUrls: ['./mawop-calculator-form-modal.component.scss']
})
export class MawopCalculatorFormModalComponent {
    form: FormGroup;
    casings: OptionItem[];
    constructor(
        public dialogRef: MatDialogRef<FormComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { data: MawopCalculator | null, action: 'create' | 'update' },
        private service: MawopService,
        private formBuilder: FormBuilder,
        private _fuseConfirmationService: FuseConfirmationService,
    ) { }

    ngOnInit() {
        this.form = this.formBuilder.group({
            id: [null],
            casing: [null],
            miyp: [null],
            mcp: [null],
        });

        if (this.data.action == 'create') {
             this.getCasing();
            return
        };

        this.form.patchValue(this.data.data.mawopCalculator[0]);
    }

    getCasing() {
        this.service.getMawopCasing().subscribe((casings) => {
            this.casings = casings.data;

            // get Intermediate Casing
            const intermediateCasing = this.casings?.find(casing => casing.id == '0FCF7223')
            this.form.patchValue({ casing: intermediateCasing?.name })
        })
    }

    save() {
        const payload: MawopCalculator = { ...this.data.data }
        payload.mawopCalculator = [this.form.getRawValue()];

        this.service.computeMawop(payload).subscribe(() => {
            this.dialogRef.close({ isUpdate: true });
        });
    }

    delete() {
        // Open the confirmation dialog
        const confirmation = this._fuseConfirmationService.open({
            title: 'Delete MAWOP Calculator',
            message: 'Are you sure you want to delete this MAWOP?',
            actions: {
                confirm: {
                    label: 'Delete',
                },
            },
        });

        confirmation.afterClosed().subscribe((result) => {
            // If the confirm button pressed...
            if (result === 'confirmed') {
                this.service.deleteMawop(this.form.get('id').value).subscribe()
                this.dialogRef.close({ isUpdate: true });
            }
        })
    }

    enableDelete(){
        return this.form.get('casing').value == 'Intermediate' && this.data.action != 'create'
    }

    disabledSave(){
        const miyp = this.form.get('miyp')?.value;
        const mcp = this.form.get('mcp')?.value;
    
        const isEmpty = (val: any) => val === null || val === undefined || val === '';
    
        return isEmpty(miyp) && isEmpty(mcp);
    }

}
